import React from 'react';

import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Kaili &amp; Savannah's Wedding</h1>
      </header>
    </div>
  );
}

export default App;
